/* tslint:disable */
/* eslint-disable */
export enum WorkProjectCheckRuleApplicableBlockTypeEnum {
  ProjectOriented = 'PROJECT_ORIENTED',
  TaskOriented = 'TASK_ORIENTED',
  Both = 'BOTH'
}
